import React, { useEffect } from 'react'
import { LayoutPage, LayoutPageHeaderStyle } from '@wallyhealth/web-core'
import styles from './index.module.css'
import intelService from 'services/intelService'
import CustomerForm from 'components/CustomerForm'

const InfoFormPage = ({ goBack, onSubmit, viewName }) => {
  useEffect(() => {
    intelService.recordView({ viewName })
  }, [])

  return (
    <LayoutPage
      headerStyle={LayoutPageHeaderStyle.FULL}
      title="Tell us a bit about yourself."
      description="We'll use this information to personalize your care."
      bodyClassName={styles.body}
      onBack={goBack}
    >
      <CustomerForm
        className={styles.form}
        buttonClassName={styles.button}
        onSubmit={onSubmit}
        buttonLabel="Next"
        viewName={viewName}
      />
    </LayoutPage>
  )
}

export default InfoFormPage
